import React from "react";

export const About = (props) => {
  return (
    <div id="about">
      <div className="container">
        <div className="row">
          <div className="col-xs-12 col-md-6">
            {" "}
            <img src="img/about.jpg" className="img-responsive" alt="" />{" "}
          </div>
          <div className="col-xs-12 col-md-6">
            <div className="about-text">
              <h2>About Us</h2>
              <p>At JW Consulting QBO LLC, our mission is to provide reliable and efficient accounting services that empower businesses to thrive. With a focus on QuickBooks solutions, we help companies improve their financial operations through streamlined processes and expert insights.</p>
              <p>Our founder, Jim W., brings over a decade of experience in both corporate and entrepreneurial settings, offering practical, real-world solutions for businesses of all sizes. Whether you're an entrepreneur looking for bookkeeping support or a growing company in need of strategic financial guidance, we're here to help.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
